'use client';

import { memo } from 'react';

import { type Clip, ClipType } from '@air/api/types';

import { ImagePreview } from '~/components/ImagePreview';
import { VideoPreview } from '~/components/VideoPreview';

export type AssetPreviewProps = {
  clip: Clip;
};

/**
 * Preview component for the asset detail modal.
 * Supports images and video.
 */
export const AssetPreview = memo(({ clip }: AssetPreviewProps) => {
  if (clip.type === ClipType.video && clip.assets?.video) {
    return <VideoPreview src={clip.assets.video} />;
  }

  const alt = clip.title ?? clip.importedName ?? 'Asset preview';
  const src = clip.assets?.image;

  return <ImagePreview alt={alt} src={src} />;
});

AssetPreview.displayName = 'AssetPreview';
